"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StackedFieldContainer = exports.InlineFieldContainer = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _Text = _interopRequireDefault(require("../../../Elements/Text"));

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

var _Flex = _interopRequireDefault(require("../../../Layout/Flex"));

var _Group = require("../Group");

var _Error = _interopRequireDefault(require("../Error"));

var _Hint = _interopRequireDefault(require("../Hint"));

var _Input = _interopRequireDefault(require("../Input"));

var _Label = _interopRequireDefault(require("../Label"));

var _reactHookForm = require("react-hook-form");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var InlineField = React.forwardRef(function (_a, ref) {
  var component = _a.component,
      errors = _a.errors,
      hint = _a.hint,
      id = _a.id,
      label = _a.label,
      name = _a.name,
      sx = _a.sx,
      _b = _a.variant,
      variant = _b === void 0 ? 'forms.inlineField' : _b,
      props = (0, _tslib.__rest)(_a, ["component", "errors", "hint", "id", "label", "name", "sx", "variant"]) // tslint:disable-next-line:align
  ;
  var inGroup = React.useContext(_Group.GroupContext).inGroup;
  return React.createElement(_Flex.default, {
    sx: (0, _tslib.__assign)({
      flexDirection: 'row',
      alignItems: 'flex-start',
      mb: inGroup ? 2 : 4,
      mr: inGroup ? 2 : 4
    }, sx),
    variant: variant
  }, React.createElement(_Box.default, {
    as: "label",
    mb: 0,
    htmlFor: id,
    sx: {
      order: 1
    }
  }, React.createElement(_Label.default, {
    as: _Text.default
  }, label), hint && React.createElement(_Hint.default, null, hint), (0, _lodash.get)(errors, name) && React.createElement(_Error.default, null, (0, _lodash.get)(errors, name))), React.createElement(_Box.default, {
    sx: {
      order: 0,
      flex: '0 0 auto'
    }
  }, React.createElement(_Box.default, (0, _tslib.__assign)({
    as: component,
    id: id,
    name: name,
    ref: ref
  }, props))));
});
var MemoizedInlineField = React.memo(function (props) {
  return React.createElement(InlineField, (0, _tslib.__assign)({
    ref: props.register
  }, props));
}, function (prevProps, nextProps) {
  if ((0, _lodash.get)(nextProps.errors, nextProps.name) && (0, _lodash.get)(prevProps.errors, prevProps.name) === (0, _lodash.get)(nextProps.errors, nextProps.name) && prevProps.formState.isDirty === nextProps.formState.isDirty) {
    return true;
  }

  return false;
});

var InlineFieldContainer = function InlineFieldContainer(props) {
  var methods = (0, _reactHookForm.useFormContext)();
  return React.createElement(MemoizedInlineField, (0, _tslib.__assign)({}, methods, props));
};

exports.InlineFieldContainer = InlineFieldContainer;
var StackedField = React.forwardRef(function (_a, ref) {
  var component = _a.component,
      errors = _a.errors,
      hint = _a.hint,
      id = _a.id,
      label = _a.label,
      name = _a.name,
      sx = _a.sx,
      _b = _a.variant,
      variant = _b === void 0 ? 'forms.stackedField' : _b,
      props = (0, _tslib.__rest)(_a, ["component", "errors", "hint", "id", "label", "name", "sx", "variant"]) // tslint:disable-next-line:align
  ;
  var inGroup = React.useContext(_Group.GroupContext).inGroup;
  return React.createElement(_Flex.default, {
    sx: (0, _tslib.__assign)({
      flexDirection: 'column',
      justifyContent: 'flex-start',
      my: inGroup ? 2 : 4
    }, sx),
    variant: variant,
    "data-test": "stacked-field"
  }, React.createElement(_Box.default, {
    as: "label",
    htmlFor: id
  }, React.createElement(_Label.default, {
    as: _Text.default,
    pb: 1
  }, label), hint && React.createElement(_Hint.default, {
    pb: 1
  }, hint), (0, _lodash.get)(errors, name) && React.createElement(_Error.default, null, (0, _lodash.get)(errors, name))), React.createElement(_Box.default, {
    pt: 1
  }, React.createElement(_Box.default, (0, _tslib.__assign)({
    as: component,
    id: id,
    name: name,
    ref: ref
  }, props))));
});
var MemoizedStackedField = React.memo(function (props) {
  return React.createElement(StackedField, (0, _tslib.__assign)({
    ref: props.register
  }, props));
}, function (prevProps, nextProps) {
  if ((0, _lodash.get)(nextProps.errors, nextProps.name) && (0, _lodash.get)(prevProps.errors, prevProps.name) === (0, _lodash.get)(nextProps.errors, nextProps.name) && prevProps.formState.isDirty === nextProps.formState.isDirty) {
    return true;
  }

  return false;
});

var StackedFieldContainer = function StackedFieldContainer(props) {
  var methods = (0, _reactHookForm.useFormContext)();
  return React.createElement(MemoizedStackedField, (0, _tslib.__assign)({}, methods, props));
};

exports.StackedFieldContainer = StackedFieldContainer;

var Field = function Field(_a) {
  var inline = _a.inline,
      props = (0, _tslib.__rest)(_a, ["inline"]);
  return inline ? React.createElement(InlineFieldContainer, (0, _tslib.__assign)({}, props)) : React.createElement(StackedFieldContainer, (0, _tslib.__assign)({}, props));
};

Field.displayName = 'Field';
Field.defaultProps = {
  component: _Input.default.Text,
  inline: false
};
var _default = Field;
exports.default = _default;